<ion-card>
  <ion-card-content [class]="'empty-result variant-' + variant()">
    @if (icon(); as iconName) {
      <ion-icon
        aria-hidden="true"
        [src]="'../assets/material-symbols/' + iconName"
      ></ion-icon>
    }
    <p class="fs-sm">{{ text() | translate }}</p>
  </ion-card-content>
</ion-card>
